import { find } from 'lodash';
import views from './views';
import selectors from './selectors';
import Homescreen from './Homescreen';
import Terms from './terms';
import Survey from './survey';

class SingleSurvey {
  renderTermOptions = (currentPage) => {
    const termsOptions = {
      elem: selectors.termsLink,
      moveBackBtn: $(selectors.moveBackBtn),
      currentPage: views.basic.terms,
      mainContent: $(selectors.mainContent),
      prevPage: currentPage,
    };

    new Terms(termsOptions).render();
  };

  render() {
    // jQuery selectors
    const body = $(selectors.body);
    const mainContent = $(selectors.mainContent);

    let currentPage = '';
    if (Pollfish.helper.json.incentive) {
      body.attr('data-page', views.common.homescreenIncentive);
      currentPage = views.common.homescreenIncentive;
    } else {
      body.attr('data-page', views.common.homescreenNonIncentive);
      currentPage = views.common.homescreenNonIncentive;
    }

    // Preview based on a question id/refId
    const headId = parseInt(Pollfish.helper.getURLParameter('head_id'), 10);
    const headRefId = Pollfish.helper.getURLParameter('head_refId');
    if (Pollfish.helper.getURLParameter('preview') === 'true') {
      Pollfish.helper.isPreview = true;
    }
    let previewNodeId;
    let targetField;
    let previewQuestion;
    // Since Pollfish.helper.getUrlParameter returns 'null' instead of null
    // we need to check headRefId if Pollfish.helper.getUrlParameter changes default value
    if (headRefId && headRefId !== 'null') {
      previewNodeId = headRefId;
      targetField = 'refId';
    } else {
      previewNodeId = headId;
      targetField = 'id';
    }

    // we need to instantiate here because the survey preprocesses things
    // used by the Homescreen
    Pollfish.survey = new Survey({
      ...Pollfish.helper.json,
    });

    if (previewNodeId) {
      Pollfish.ui.hideCloseButtonFromHeader();
      Pollfish.helper.getInitialHeight();

      const group = find(Pollfish.survey.groups, [targetField, previewNodeId]);
      if (group) {
        // this is a nice hack/side effect since we are already handling
        // groups etc for "startFromQuestion" API
        Pollfish.survey.start({
          startFromQuestion: group.getNextQuestion(),
        });
        return;
      }
      previewQuestion = find(Pollfish.survey.props.questions, [
        targetField,
        previewNodeId,
      ]);
      if (previewQuestion) {
        Pollfish.survey.start({ startFromQuestion: previewQuestion });
      }
    }

    if (
      Pollfish.helper.isRouterRedirect ||
      Pollfish.helper.shouldHideHomescreen()
    ) {
      if (previewQuestion) {
        Pollfish.survey
          .start({ startFromQuestion: previewQuestion })
          .catch(Pollfish.helper.handleError);
      } else {
        Pollfish.survey.start().catch(Pollfish.helper.handleError);
      }
      return;
    }

    const homescreen = new Homescreen().render();
    mainContent.html(homescreen);

    this.renderTermOptions(currentPage);
  }
}

export default SingleSurvey;
